export const CATEGORY_PATH_SEPARATOR = ' → '

export const formatCategoryPathLabel = (path = []) => path.join(CATEGORY_PATH_SEPARATOR)

export const createCategorySelection = ({
  source = 'premium',
  level,
  globalCategory,
  path,
  brandIds = [],
  outletGlobalCategoryId = null,
  productFilter = null,
}) => ({
  related_category_source: source,
  related_category_level: level,
  related_global_category_id: globalCategory.id,
  related_global_category_name: globalCategory.name,
  related_outlet_global_category_id: outletGlobalCategoryId,
  related_global_category_path: path,
  related_category_path_label: formatCategoryPathLabel(path),
  brandIds,
  related_product_filter: productFilter,
})

const findPremiumNodeInTree = (tree, selection) => {
  const globalCategory = tree.find((node) => node.id === selection.related_global_category_id)

  if (!globalCategory || globalCategory.source === 'outlet') {
    return null
  }

  const path = selection.related_global_category_path || []

  if (path.length <= 1) {
    return globalCategory
  }

  const categoryNode = globalCategory.children?.find((node) => node.name === path[1])

  if (!categoryNode) {
    return null
  }

  if (path.length === 2) {
    return categoryNode
  }

  return categoryNode.children?.find((node) => node.name === path[2]) || null
}

const findOutletNodeInTree = (tree, selection) => {
  const outletRoot = tree.find((node) => node.level === 'outlet_root')

  if (!outletRoot) {
    return null
  }

  const path = selection.related_global_category_path || []

  if (path.length <= 1) {
    return outletRoot
  }

  const outletGlobal = outletRoot.children?.find((node) => node.name === path[1])

  if (!outletGlobal) {
    return null
  }

  if (path.length === 2) {
    return outletGlobal
  }

  const categoryNode = outletGlobal.children?.find((node) => node.name === path[2])

  if (!categoryNode) {
    return null
  }

  if (path.length === 3) {
    return categoryNode
  }

  return categoryNode.children?.find((node) => node.name === path[3]) || null
}

export const findCategoryNodeInTree = (tree, selection) => {
  if (!selection?.related_global_category_id) {
    return null
  }

  if (selection.related_category_source === 'outlet') {
    return findOutletNodeInTree(tree, selection)
  }

  return findPremiumNodeInTree(tree, selection)
}

export const isCategorySelectionValid = (selection, tree) => {
  if (!selection) {
    return true
  }

  return Boolean(findCategoryNodeInTree(tree, selection))
}
